
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import { ApiUrl } from "../../../ApiUrl";

const SelectStudentModal = ({ show, handleClose, onSelectStudent }) => {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [students, setStudents] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState(new Set());
  const { classes, loading: classLoading, error: classError } = useFetchClasses();
  const [studentData, setStudentData] = useState([]);
  const [fullStudentData, setFullStudentData] = useState([]);

  const [filters, setFilters] = useState({
    studentName: "",
    admissionNo: "",
    barcode: "",
    classId: "",
    section: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });

  useEffect(() => {
    const fetchFullStudentData = async () => {
      try {
        const academicSessionId = localStorage.getItem('academicSessionId');
        if (!academicSessionId) {
          console.error('No academic session ID found in local storage');
          return;
        }
        const response = await fetch(`${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`);
        if (!response.ok) {
          throw new Error('Error fetching student data');
        }
        const data = await response.json();
        if (data.data) {
          setFullStudentData(data.data);
          setStudentData(data.data);
        } else {
          console.warn('No data found for the given academic session ID');
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchFullStudentData();
  }, []);

  // Reset modal state when closed
  useEffect(() => {
    if (!show) {
      setFilters({
        studentName: "",
        admissionNo: "",
        barcode: "",
        classId: "",
        section: "",
        fatherName: "",
        motherName: "",
        schoolAdmissionNo: "",
      });
      setSelectedClass("");
      setSelectedSection("");
      setStudentData(fullStudentData);
      setSelectedStudents(new Set());
    }
  }, [show, fullStudentData]);

  const handleSelectStudent = (student) => {
    setSelectedStudents((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(student)) {
        newSelected.delete(student);
      } else {
        newSelected.add(student);
      }
      return newSelected;
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedStudents(new Set(studentData));
    } else {
      setSelectedStudents(new Set());
    }
  };

  const handleSelect = () => {
    if (typeof onSelectStudent === 'function') {
      onSelectStudent(Array.from(selectedStudents));
      handleClose();
    } else {
      console.error('onSelectStudent is not a function');
    }
  };

  const { sections, loading: sectionLoading, error: sectionError } = useFetchSections(selectedClass);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    const filteredData = fullStudentData.filter((student) => {
      const studentDetails = student.studentBasicDetails;
      const fullName = `${studentDetails.first_name} ${studentDetails.middle_name || ''} ${studentDetails.last_name}`.trim().toLowerCase();
      const searchParts = filters.studentName.toLowerCase().split(' ').filter(Boolean);
      const nameMatches = searchParts.every(part => fullName.includes(part));
      return (
        (!filters.studentName || nameMatches) &&
        (!filters.admissionNo || studentDetails.school_admission_no.toString().includes(filters.admissionNo)) &&
        (!filters.barcode || studentDetails.barcode.toString().includes(filters.barcode)) &&
        (!filters.schoolAdmissionNo || studentDetails.admission_no.toString().includes(filters.schoolAdmissionNo)) &&
        (!filters.classId || studentDetails.addmitted_class.toString() === filters.classId.toString()) &&
        (!filters.section || studentDetails.addmitted_section === filters.section) &&
        (!filters.fatherName || studentDetails.father_name.toLowerCase().includes(filters.fatherName.toLowerCase())) &&
        (!filters.motherName || studentDetails.mother_name.toLowerCase().includes(filters.motherName.toLowerCase()))
      );
    });
    setStudentData(filteredData);
  };

  const getClassName = (classId) => {
    const classObj = classes.find((cls) => cls.id === classId);
    return classObj ? classObj.classname : "N/A";
  };

  // const getSectionName = (sectionId) => {
  //   const sectionObj = sections.find((sec) => sec.id === sectionId);
  //   return sectionObj ? sectionObj.sectionname : "N/A";
  // };

  const getSectionName = (sectionId) => {
    const sectionObj = sections.find((sec) => sec.section_id === sectionId);
    return sectionObj ? sectionObj.sectionname : "N/A";
  };

  const handleClearFilters = () => {
    setFilters({
      studentName: "",
      admissionNo: "",
      barcode: "",
      classId: "",
      section: "",
      fatherName: "",
      motherName: "",
      schoolAdmissionNo: "",
    });
    setSelectedClass("");
    setSelectedSection("");
    setStudentData(fullStudentData);
    setSelectedStudents(new Set());
  };


  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={handleClose}></Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card p-0">
                <div className="card-body">
                  <p
                    style={{
                      marginBottom: "0px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    STUDENT SEARCH
                  </p>
                  <div className="row mb-2">
                    <div className="col-12 d-flex flex-wrap gap-2">
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        style={{ width: "150px" }}
                        onClick={handleClearFilters}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{ width: "150px" }}
                        onClick={handleClose}
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSelect}
                      >
                        Select
                      </button>
                    </div>
                  </div>
                  {/* Search Fields */}
                  <div className="row mt-3">
                    <div className="col-3">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Student Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        name="studentName"
                        value={filters.studentName}
                        onChange={handleInputChange}
                        placeholder="Student Name"
                      />
                    </div>
                    <div className="col-3">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Admission No{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        name="admissionNo"
                        value={filters.admissionNo}
                        onChange={handleInputChange}
                        placeholder="Admission No"
                      />
                    </div>
                    <div className="col-3">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Barcode{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        name="barcode"
                        value={filters.barcode}
                        onChange={handleInputChange}
                        placeholder="Barcode"
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-3">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Class{" "}
                      </label>
                      <select
                        className="form-control detail"
                        name="classId"
                        value={filters.classId}
                        onChange={(e) => {
                          handleInputChange(e);
                          setSelectedClass(e.target.value);
                        }}
                      >
                        <option value="">Select Class</option>
                        {classes.map((cls) => (
                          <option key={cls.id} value={cls.id}>
                            {cls.classname}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Section{" "}
                      </label>
                      <select
                        className="form-control detail"
                        name="section"
                        value={filters.section}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            section: e.target.value ? Number(e.target.value) : "",
                          }))
                        }
                      >
                        <option value="">Select Section</option>
                        {sections.map((sec) => (
                          <option key={sec.section_id} value={sec.section_id}>
                            {sec.sectionname}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Father's Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        name="fatherName"
                        value={filters.fatherName}
                        onChange={handleInputChange}
                        placeholder="Father Name"
                      />
                    </div>
                    <div className="col-3">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Mother's Name{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control detail"
                        name="motherName"
                        value={filters.motherName}
                        onChange={handleInputChange}
                        placeholder="Mother Name"
                      />
                    </div>
                  </div>
                  {/* Students Table */}
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                selectedStudents.size === studentData.length
                              }
                            />
                          </th>
                          <th>Student Name</th>
                          <th>Admission No</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>Student Barcode</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentData.map((student, index) => {
                          const studentDetails = student.studentBasicDetails;
                          const fullName = `${studentDetails.first_name} ${studentDetails.middle_name || ""
                            } ${studentDetails.last_name}`;
                          return (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedStudents.has(student)}
                                  onChange={() => handleSelectStudent(student)}
                                />
                              </td>
                              <td>{fullName}</td>
                              <td>{studentDetails.admission_no}</td>
                              <td>
                                {getClassName(studentDetails.addmitted_class)}
                              </td>
                              <td>
                                {/* {getSectionName(studentDetails.addmitted_section)} */}
                                {studentDetails.sectionname}
                              </td>
                              <td>{studentDetails.father_name}</td>
                              <td>{studentDetails.mother_name}</td>
                              <td>{studentDetails.barcode}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectStudentModal;

